<template>
    <span>
        <font-awesome-icon
            v-if="params.data.damage_notice_source_id"
            :icon="['fas', 'house-chimney-crack']"
            size="lg"
            class="text-primary"
            title="Damage Notice source"
        />
    </span>
</template>

<script>
export default {};
</script>
